import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deleteData, getData, getDataById, postData, postDataWithParams, updateData } from "../../../service/Service";

const initialState = {
  data: {
    docs: [],
  },
  dashboard: [],
  updatedTime:0,
  isLoading: false,
  isError: "",
  message: "",
  postMessage: "",
  postStatus: "",
  deleteMessage: "",
  deleteStatus: "",
  updateMessage: "",
  updateStatus: "",
};

export const getHarvestEstimate = createAsyncThunk(
  "farmer/harvest-estimate",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getData("/farmer/harvest-estimate", data.token, data.params);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);
export const getHarvestEstimateById = createAsyncThunk(
  "farmer/harvest-estimate/id",
  async (data, { rejectWithValue }) => {
    try {
      const result = await getDataById("/farmer/harvest-estimate/", data.token, data.id);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const sortHarvestEstimate = createAsyncThunk(
  "farmer/harvest-estimate/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/farmer/harvest-estimate/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const getHarvestEstimateDashboard = createAsyncThunk(
  "farmer/harvest-estimate/sort",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postDataWithParams(
        "/farmer/harvest-estimate/search",
        data.token,
        data.body,
        data.params
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const postHarvestEstimate = createAsyncThunk(
  "farmer/harvest-estimate/post",
  async (data, { rejectWithValue }) => {
    try {
      const result = await postData("/farmer/harvest-estimate", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteHarvestEstimate = createAsyncThunk(
  "farmer/harvest-estimate/delete",
  async (data, { rejectWithValue }) => {
    try {
      const result = await deleteData("/farmer/harvest-estimate/", data.token, data.data);
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateHarvestEstimate = createAsyncThunk(
  "farmer/harvest-estimate/edit",
  async (data, { rejectWithValue }) => {
    try {
      const result = await updateData(
        "/farmer/harvest-estimate/",
        data.token,
        data.id,
        data.value
      );
      return result.data;
    } catch (err) {
      return rejectWithValue(err.response.data);
    }
  }
);

const harvestEstimateSlice = createSlice({
  name: "Harvest Estimate Store",
  initialState: initialState,
  reducers: {
    addHarvestEstimate(state, action) {
      state.data.docs.unshift(action.payload);
    },
    sortHarvestEstimate(state, action) {
      state.data.docs = action.payload;
    },
    deleteHarvestEstimate(state, action) {
      state.data.docs = state.data.docs.filter(
        (item) => item._id !== action.payload
      );
    },
    editHarvestEstimate(state, action) {
      let x = state.data.docs.findIndex((item) => item._id === action.payload._id);
      state.data.docs[x] = action.payload;
    },
  },
  extraReducers: {
    [getHarvestEstimate.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getHarvestEstimate.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.updatedTime = Date.now();
      state.message = action.payload.message;
    },
    [getHarvestEstimate.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getHarvestEstimateById.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getHarvestEstimateById.fulfilled]: (state, action) => {
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getHarvestEstimateById.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortHarvestEstimate.pending]: (state, ) => {
      state.isLoading = true;
    },
    [sortHarvestEstimate.fulfilled]: (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [sortHarvestEstimate.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [postHarvestEstimate.pending]: (state, ) => {
      state.isLoading = true;
    },
    [postHarvestEstimate.fulfilled]: (state, action) => {
      state.postMessage = action.payload.message;
      state.postStatus = action.payload.status;
    },
    [postHarvestEstimate.rejected]: (state, action) => {
      state.isError = true;
      state.postMessage = action.payload.message;
    },
    [deleteHarvestEstimate.pending]: (state, ) => {
      state.isLoading = true;
    },
    [deleteHarvestEstimate.fulfilled]: (state, action) => {
      state.deleteMessage = action.payload.message;
      state.deleteStatus = action.payload.status;
    },
    [deleteHarvestEstimate.rejected]: (state, action) => {
      state.isError = true;
      state.deleteMessage = action.payload.message;
    },
    [updateHarvestEstimate.pending]: (state, ) => {
      state.isLoading = true;
    },
    [updateHarvestEstimate.fulfilled]: (state, action) => {
      state.updateMessage = action.payload.message;
      state.status = action.payload.status;
    },
    [updateHarvestEstimate.rejected]: (state, action) => {
      state.isError = true;
      state.updateMessage = action.payload.message;
    },
    [getHarvestEstimateDashboard.pending]: (state, ) => {
      state.isLoading = true;
    },
    [getHarvestEstimateDashboard.fulfilled]: (state, action) => {
      state.dashboard = action.payload.data.docs;
      state.isError = false;
      state.isLoading = false;
      state.message = action.payload.message;
    },
    [getHarvestEstimateDashboard.rejected]: (state, action) => {
      state.isError = true;
      state.isLoading = false;
      state.message = action.payload.message;
    }
  },
});

export const harvestEstimateActions = harvestEstimateSlice.actions;

export default harvestEstimateSlice.reducer;
